import React from 'react';
import { ReactComponent as SearchIcon } from "@/assets/svgs/DesignSystem/search-icon.svg";
import { ReactComponent as CancelIcon } from "@/assets/svgs/DesignSystem/x-mark.svg";
import Input from '@/componentsDS/Input/index';
import PropTypes from 'prop-types';

const Search = ({ name, value, placeholder, variant = 'outlined', disabled = false, onCancel, onChange }) => {
	return <Input placeholder={placeholder ?? 'Search'} name={name ?? 'search'} value={value} cancelIcon={<CancelIcon />} prefixIcon={<SearchIcon />} handleOnCancel={onCancel} handleOnChange={onChange} variant={variant} disabled={disabled} />;
};

Search.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    onCancel: PropTypes.func,
    onChange: PropTypes.func
};


export default Search;
